import { render, staticRenderFns } from "./Step_5.vue?vue&type=template&id=875743da&"
import script from "./Step_5.vue?vue&type=script&lang=js&"
export * from "./Step_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports